import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const toneClass = {
    neutral: 'bg-muted-foreground/45',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger',
    info: 'bg-info'
};
/** Smallest semantic status indicator. */ export const SpecraStatusDot = /*#__PURE__*/ React.forwardRef(({ className, label, size = 'md', tone = 'neutral', ...props }, ref)=>/*#__PURE__*/ _jsx("span", {
        "aria-hidden": label ? undefined : true,
        "aria-label": label,
        className: cn('inline-block shrink-0 rounded-full', size === 'sm' ? 'size-1' : 'size-1.5', toneClass[tone], className),
        ref: ref,
        role: "img",
        ...props
    }));
SpecraStatusDot.displayName = 'SpecraStatusDot';
